const IsServerSideRendering = () => {
  try {
    return typeof window === 'undefined';
  } catch (e) {
    return true;
  }
};

export default IsServerSideRendering;
